export default class CDNOrigin {

  constructor() {
    this.form = document.getElementById('cdn_origin_update');
    const self = this;

    if (this.form) {
      window.solodev.submitForm = () => this.form.submit();

      const protocolInputRadios = this.form.querySelectorAll('.js-protocol .form-check-input');
      if (protocolInputRadios.length) {
        for (const input of protocolInputRadios) {
          if (input.checked) {
            this.onProtocolChange(input.value)
          }

          input.addEventListener('change', (event) => {
            self.onProtocolChange(event.target.value)
          })
        }
      }
    }
  }

  onProtocolChange(value) {
    const httpInput = this.form.querySelector('#cdn_origin_update_port_http');
    const httpsInput = this.form.querySelector('#cdn_origin_update_port_https');
    const minSLLRadios = this.form.querySelectorAll('.js-min-ssl .form-check-input');
    switch (value) {
      case 'http':
        httpInput.readOnly = false;
        httpsInput.readOnly = true;
        for (const radio of minSLLRadios) {
          radio.disabled = true
        }
        break;
      case 'https':
        httpInput.readOnly = true;
        httpsInput.readOnly = false;
        for (const radio of minSLLRadios) {
          radio.disabled = false
        }
        break;
      case 'match':
        httpInput.readOnly = false;
        httpsInput.readOnly = false;
        for (const radio of minSLLRadios) {
          radio.disabled = false
        }
        break;
      default:
        throw TypeError(`${ value } is not a valid value for protocol`);
    }
  }
}
